import axios from 'axios';
import { SimulationRequest, SimulationResponse } from '../types/simulation';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30秒タイムアウト
  headers: {
    'Content-Type': 'application/json',
  },
});

export const simulationApi = {
  /**
   * モンテカルロシミュレーションを実行
   */
  async runSimulation(params: SimulationRequest): Promise<SimulationResponse> {
    try {
      const response = await apiClient.post<SimulationResponse>('/simulate', params);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.detail || 
          error.message || 
          'シミュレーション実行中にエラーが発生しました'
        );
      }
      throw new Error('予期しないエラーが発生しました');
    }
  },

  /**
   * APIの健康状態をチェック
   */
  async healthCheck(): Promise<{ status: string; service: string }> {
    try {
      const response = await apiClient.get('/health');
      return response.data;
    } catch (error) {
      throw new Error('APIサーバーに接続できません');
    }
  },

  /**
   * シミュレーション情報を取得
   */
  async getSimulationInfo(): Promise<any> {
    try {
      const response = await apiClient.get('/simulation/info');
      return response.data;
    } catch (error) {
      throw new Error('シミュレーション情報の取得に失敗しました');
    }
  }
};

export default simulationApi; 